module.exports = __webpack_public_path__ + "img/note-down.da3106b7.png";